import React, { Component } from 'react'
import { Button } from '../../../../../packages/components'
import { showModal, MODAL_COUNTRY_DETAILS } from '../../../../../actions/modal'
import store from '../../../../../store'
import './_card.scss'
import Utils from '../../../../../utils/Utils'
import { STAR_EMPTY, STAR_FILLED } from '../../constants'
import Asset from '../../../../../requests/apa/Asset'

class CountryCard extends Component {

  getLastFocus = ()=>{ 
    const lastFocus = document.activeElement.getAttribute('id');
    return `#${lastFocus}`;
  }

  handleClick = () => {
    localStorage.setItem('lastFocusPais', this.getLastFocus());
    const { onClickFavorite, mainMenuLabel, parentTabLabel, childTabLabel } = this.props
    store.dispatch(showModal({
      modalType: MODAL_COUNTRY_DETAILS,
      modalProps: {
        countryId: this.props.id,
        onClickFavorite: onClickFavorite,
        mainMenuLabel: mainMenuLabel,
        parentTabLabel: parentTabLabel,
        childTabLabel: childTabLabel
      }
    }))
  }

  render () {
    const { name, logo, flag, color, favorited, id } = this.props

    return (
      <Button
        id={`card-pais-${id}`}
        className='focusable pais-card'
        onClick={this.handleClick}
      >
        <div className='pais-card__left-strip' style={{ backgroundColor: color }} />

        <div className='pais-card__container-content'>

          <div className='pais-card__logo-wrapper'>
            <img src={logo} alt='' />
          </div>

          <div className='pais-card__flag-wrapper'>
            <img src={flag} alt='' />
          </div>

          <div className='pais-card__separator' />

          <div className='pais-card__text-container'>
            <p className='pais-card__name'>{Utils.cutPlayerString(name, 14)}</p>

            <div className='pais-card__favorite'>
              <img src={Asset.get(favorited ? STAR_FILLED : STAR_EMPTY)} alt='' />
            </div>
          </div>

        
        </div>
      </Button>
    )
  }
}

export default CountryCard



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryCard/index.jsx